import {createContext, useState} from "react";
import {
    getCurrentBusDateFromCalService
} from "utils/FormatUtils";

export const SWIFT_WIRES_PANEL_ACTIVITIES_PAGE = "swift-wires-activities";

export const Context = createContext({});

export const Provider = props => {

    const {children} = props;

    const startDate = getCurrentBusDateFromCalService();

    const getRowStyle = (params) => {
        if (!params.data) return {};
        return params.data.uiStatus ===  'ERROR' || params.data.uiStatus ===  'ERROR - TD TO AMEND'? {backgroundColor: '#f5efef'} : {};
    }

    const initSwiftWiresDisplayState = {
        swiftWiresActivitiesSearch: {
            managerId: '',
            managerName: '',
            subManagerId: '',
            subManagerName: '',
            accountId: '',
            accountCode: '',
            accountName: '',
            refType:'',
            reference:'',
            transId:'',
            status:'ACK',
            direction:'OUT',
            dtEffective: startDate,
            resData: [],
            badgeInfo: ''
        },
        currentPage : SWIFT_WIRES_PANEL_ACTIVITIES_PAGE
    }

    const [showGridToolbar, setShowGridToolbar] = useState(true);
    const [swiftWiresDisplayState, setSwiftWiresDisplayState] = useState(JSON.parse(JSON.stringify(initSwiftWiresDisplayState)));
    const [headerCheckboxChecked, setHeaderCheckedboxChecked] = useState(false);
    const [selectedAnyCheckbox, setSelectedAnyCheckbox] = useState(false);
    const [selectedRows, setSelectedRows] = useState([])
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [columnState, setColumnState] = useState(null)
    const [viewClicked, setViewClicked] = useState(false);
    const handlePageRequest =(pageName)=>{
        const newFilterState = {...swiftWiresDisplayState}
        newFilterState['currentPage'] = pageName;
        setSwiftWiresDisplayState(newFilterState);
    }


    const clearSwiftWiresSearchAndLoadHome = () => {
        setSwiftWiresDisplayState(JSON.parse(JSON.stringify(initSwiftWiresDisplayState)));
    }
    const buildSwiftWiresActivitiesSearch = (managerId, managerName, subManagerId, subManagerName, accountId, accountCode, accountName, status, startDate, endDate, resData) => {
        let swiftWiresActivitiesSearch = JSON.parse(JSON.stringify(initSwiftWiresDisplayState.swiftWiresActivitiesSearch));
        swiftWiresActivitiesSearch.managerId = managerId;
        swiftWiresActivitiesSearch.managerName = managerName;
        swiftWiresActivitiesSearch.subManagerId = subManagerId;
        swiftWiresActivitiesSearch.subManagerName = subManagerName;
        swiftWiresActivitiesSearch.accountId = accountId;
        swiftWiresActivitiesSearch.accountCode = accountCode;
        swiftWiresActivitiesSearch.accountName = accountName;
        swiftWiresActivitiesSearch.status = status;
        swiftWiresActivitiesSearch.startDate = startDate;
        swiftWiresActivitiesSearch.endDate = endDate;
        swiftWiresActivitiesSearch.resData = resData;
        swiftWiresActivitiesSearch.badgeInfo = accountCode && accountName ? accountCode + '-'+ accountName : 'ALL'

        return swiftWiresActivitiesSearch;
    }



    const swiftWiresContext = {
        swiftWiresDisplayState,
        setSwiftWiresDisplayState,
        showGridToolbar,
        setShowGridToolbar,
        clearSwiftWiresSearchAndLoadHome,
        buildSwiftWiresActivitiesSearch,
        headerCheckboxChecked,
        setHeaderCheckedboxChecked,
        selectedRows,
        setSelectedRows,
        selectedAnyCheckbox,
        setSelectedAnyCheckbox,
        gridColumnApi,
        setGridColumnApi,
        columnState,
        setColumnState,
        viewClicked,
        setViewClicked,
        getRowStyle,
        handlePageRequest
    }

    return <Context.Provider value={swiftWiresContext}>{children}</Context.Provider>
};

export const {Consumer} = Context;
